<form class="m-h-12 m-v-32"
  [formGroup]="form">
  <h3>{{ 'sigt.integration.commenterPlanTravail.form.title' | translate }}</h3>

  <igo-geometry-form-field-input [formControl]="form.controls.positionSurCarte"
    [map]="map"
    [geometryType]="geometryType"
    [drawGuide]="1000"
    [measure]="false"
    [drawControlIsActive]="true"
    [freehandDrawIsActive]="false"
    [drawStyle]="drawStyle$ | async"
    [radius]="radius"></igo-geometry-form-field-input>

  <div>
    <mat-label class="colorText">{{ 'sigt.integration.commenterPlanTravail.form.sousTitle' | translate }}</mat-label>
  </div>

  <br>

  <div>
    <b><mat-label>{{ 'sigt.integration.commenterPlanTravail.form.nom' | translate }}</mat-label></b><br>
    <mat-label class="colorText">{{ nom | async }}</mat-label><br>
  </div>

  <br>

  <div>
    <b><mat-label>{{ 'sigt.integration.commenterPlanTravail.form.courriel' | translate }}</mat-label></b><br>
    <mat-label class="colorText">{{ courriel | async }}</mat-label>

    <br>
  </div>

  <br>

  <mat-form-field class="d-flex">
    <mat-label>{{ 'sigt.integration.commenterPlanTravail.form.typeDePlan' | translate }}</mat-label>
    <mat-select formControlName="typePlan">
      <mat-option *ngFor="let entry of listeTypeDePlan"
        [value]="entry.valeur">{{ entry.description }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="d-flex">
    <mat-label>{{ 'sigt.integration.commenterPlanTravail.form.positionSurCarte' | translate }}</mat-label>

    <input matInput
      readonly
      formControlName="positionSurCarteForViewOnly"
      class="form-control" />
    <mat-icon matSuffix (click)="initialiserPositionCarte()">location_on</mat-icon>
    <mat-hint [ngClass]="{positionSurCarteVide: form?.controls.positionSurCarteForViewOnly.value === ''}">{{
      'sigt.integration.commenterPlanTravail.form.positionSurCarteHint' | translate }}</mat-hint>
  </mat-form-field>

  <mat-form-field class="d-flex tailletextArea">
    <mat-label><b>{{ 'sigt.integration.commenterPlanTravail.form.commentaire.libelle' | translate }}</b></mat-label>
    <textarea matInput
      #commentaire
      formControlName="commentaire"
      cdkAutosizeMinRows="5"
      required
      maxlength="4000"
      placeholder="{{ 'sigt.integration.commenterPlanTravail.form.commentaire.libelle' | translate }}"></textarea>
    <mat-error
      *ngIf="form?.controls.commentaire.errors?.minlength">{{messageApplication.invalideCommentaireCourt}}</mat-error>
    <mat-error
      *ngIf="form?.controls.commentaire.errors?.pattern">{{messageApplication.invalideCommentairePattern}}</mat-error>
    <mat-error
      *ngIf="form?.controls.commentaire.errors?.required">{{messageApplication.obligatoireCommentaire}}</mat-error>
    <mat-hint>{{ 'sigt.integration.commenterPlanTravail.form.commentaire.libelleTailleMax' | translate }}</mat-hint>
  </mat-form-field>

  <div class="boutons-en-grille">
    <button mat-raised-button
      class="clear-search-button"
      (click)="initialiserChamps()">
      {{ 'sigt.global.boutons.annuler' | translate }}
    </button>

    <button mat-raised-button
      class="search-button"
      [disabled]="!form.valid"
      color="primary"
      (click)="submitForm()">
      {{ 'sigt.global.boutons.soumettre' | translate }}
    </button>
  </div>
</form>